<template>
   <div class="tw-mx-2  tw-mt-4 tw-grid tw-grid-cols-3 tw-gap-4">
    <div class="card tw-border-0 ">
            <div class="tw-flex tw-justify-between tw-items-center">
                <h5 class="tw-text-[#00555A] tw-text-[16px] tw-align-center">GRN Sheet</h5>
                <button :disabled="templateDownloadLoader" @click="downloadTemplate('reco')" class="tw-cursor-pointer tw-px-2 tw-py-1 tw-bg-primary_brand-80 tw-rounded-lg" title="Download Template">
                     <svg v-if="templateDownloadLoader && selectedTemplateType=='reco'"  aria-hidden="true" role="status" class="tw-inline tw-w-4 tw-h-4  tw-text-white tw-animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                      </svg>
                    <img v-else src="Icons_SVG/DownloadIcon.svg" class="tw-h-5"/>
                </button>
                <!-- <div>Download</div> -->
            </div>
            <div class="tw-border tw-border-b-[1px] tw-border-[#D4D4D4] tw-my-2 tw-mb-3"></div>
            <div class="modal-delete-content tw-pt-0">
                <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                    Vehicle Date
                </div>
                <date-range-picker v-model="GRNVDDateRange" :show-dropdowns="true" opens="right" :autoApply="true"
                    :locale-data="{ format: 'dd mmm yyyy' }"  @update="formateDate"
                    class="tw-w-full tw-min-w-0" :single-date-picker="true"  :ranges="false">
                </date-range-picker>

                <div class="tw-grid tw-grid-cols-1 tw-mt-6 tw-gap-6">
                    <div>
                        <div class="tw-w-full">
                            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                                GRN Sheet
                            </div>
                            <input :disabled="GRNSheetLoader" type="file" class="d-none" accept=".xlsx" id="GRNSheet"
                                onclick="this.value = null" @change="uploadGRNSheet($event)"/>
                            <label for="GRNSheet" class="tw-mb-0 tw-w-full">
                                <div
                                    class="btn primarycolor tw-bg-accent_color tw-text-[#fff] tw-text-base tw-font-bold tw-w-full">
                                    {{ GRNSheetLoader ? "Uploading..." : "Upload" }}
                                </div>
                            </label>
                            <div class="tw-mt-1 tw-text-[12px]">{{ GRNSheetFileName }}</div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-border tw-border-b-[1px] tw-border-[#D4D4D4] tw-my-6"></div>
            <div class="tw-grid tw-grid-cols-2 tw-gap-4 ">
                <div>
                    <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                        PO Date
                    </div>
                    <date-range-picker v-model="GRNPDDateRange" :show-dropdowns="true" opens="right" :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }"  @update="formateDate"
                        class="tw-w-full tw-min-w-0"  :single-date-picker="true" :ranges="false">
                    </date-range-picker>
                </div>
                <div>
                    <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                        Putaway Date
                    </div>
                    <date-range-picker v-model="GRNPutwayDateRange" :show-dropdowns="true" opens="right" :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }"  @update="formateDate"
                        class="tw-w-full tw-min-w-0" :single-date-picker="true" :ranges="false">
                    </date-range-picker>
                </div>
            </div>
            <div class="tw-flex tw-justify-end tw-mt-8">
                <button class="btn primarycolor" :disabled="isGRNSheetUploading" @click="handleGRNUploadFile">
                    <span> {{ isGRNSheetUploading ? "Saving..." : "Save" }}</span>
                </button>
            </div>
    </div> 
    <div class="card tw-border-0 ">
            <div class="tw-flex tw-justify-between tw-items-center">
                <h5 class="tw-text-[#00555A] tw-text-[16px] ">Linking Sheet</h5>
                 <button :disabled="templateDownloadLoader"  @click="downloadTemplate('link')" class="tw-cursor-pointer tw-px-2 tw-py-1 tw-bg-primary_brand-80 tw-rounded-lg" title="Download Template">
                     <svg v-if="templateDownloadLoader && selectedTemplateType=='link'"  aria-hidden="true" role="status" class="tw-inline tw-w-4 tw-h-4  tw-text-white tw-animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                      </svg>
                    <img v-else src="Icons_SVG/DownloadIcon.svg" class="tw-h-5"/>
                </button>
            </div>
            <div class="tw-border tw-border-b-[1px] tw-border-[#D4D4D4] tw-my-2 tw-mb-3"></div>
            <div class="modal-delete-content tw-pt-0">
                <div class="tw-grid tw-grid-cols-1 tw-gap-6">
                    <div>
                        <div class="">
                            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                                Linking Sheet
                            </div>
                            <input :disabled="linkingSheetLoader" type="file" class="d-none" accept=".xlsx"
                                id="link+row.platform_id + '_file'" onclick="this.value = null" @change="uploadLinkingSheet($event)"/>
                            <label for="link+row.platform_id + '_file'" class="tw-mb-0 tw-w-full">
                                <div
                                    class="btn primarycolor tw-bg-accent_color tw-text-[#fff] tw-text-base tw-font-bold tw-w-full">
                                    {{ linkingSheetLoader ? "Uploading..." : "Upload" }}
                                </div>
                            </label>
                            <div class="tw-mt-1 tw-text-[12px]">{{ linkingSheetFileName }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-justify-end tw-mt-8 tw-absolute tw-bottom-3 tw-right-3">
                <button class="btn primarycolor" :disabled="isLinkingSheetUploading" @click="handleLinkUploadFile">
                    <span> {{ isLinkingSheetUploading ? "Saving..." : "Save" }}</span>
                </button>
            </div>
    </div> 
    <div class="card tw-border-0 ">
            <div class="tw-flex tw-justify-between tw-items-center">
                <h5 class="tw-text-[#00555A] tw-text-[16px] ">DRR Sheet</h5>
                 <button :disabled="templateDownloadLoader"  @click="downloadTemplate('drr')" class="tw-cursor-pointer tw-px-2 tw-py-1 tw-bg-primary_brand-80 tw-rounded-lg" title="Download Template">
                     <svg v-if="templateDownloadLoader && selectedTemplateType=='drr'"  aria-hidden="true" role="status" class="tw-inline tw-w-4 tw-h-4  tw-text-white tw-animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                      </svg>
                    <img v-else src="Icons_SVG/DownloadIcon.svg" class="tw-h-5"/>
                </button>
            </div>
            <div class="tw-border tw-border-b-[1px] tw-border-[#D4D4D4] tw-my-2 tw-mb-3"></div>
            <div class="modal-delete-content tw-pt-0">
                <div class="tw-grid tw-grid-cols-1 tw-gap-6">
                    <div>
                        <div class="">
                            <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1">
                                DRR Sheet
                            </div>
                            <input :disabled="DRRSheetLoader" type="file" class="d-none" accept=".xlsx"
                                id="DRR+row.platform_id + '_file'" onclick="this.value = null" @change="uploadDRRSheet($event)"/>
                            <label for="DRR+row.platform_id + '_file'" class="tw-mb-0 tw-w-full">
                                <div
                                    class="btn primarycolor tw-bg-accent_color tw-text-[#fff] tw-text-base tw-font-bold tw-w-full">
                                    {{ DRRSheetLoader ? "Uploading..." : "Upload" }}
                                </div>
                            </label>
                            <div class="tw-mt-1 tw-text-[12px]">{{ DRRSheetFileName }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-justify-end tw-mt-8 tw-absolute tw-right-4 tw-bottom-4">
                <button class="btn primarycolor" :disabled="isDRRSheetUploading" @click="handleDRRUploadFile">
                    <span> {{ isDRRSheetUploading ? "Saving..." : "Save" }}</span>
                </button>
            </div>
    </div> 
    </div> 
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
export default {
   components:{Datepicker},
   data:function (){
    return {
        GRNVDDateRange: {
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
        },
        GRNPDDateRange: {
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
        },
        GRNPutwayDateRange: {
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
        },
        // loader variable 
        GRNSheetLoader:false,
        linkingSheetLoader:null,
        DRRSheetLoader:null,
        isLinkingSheetUploading:false,
        isGRNSheetUploading:false,
        isGRNSheetUploading:false,
        isUploading:false,
        isDRRSheetUploading:false,
        templateDownloadLoader:false,
        // file variable
        selectedTemplateType:null,
        uploadedGRNSheet:null,
        GRNSheetFileName:null,
        uploadedLinkingSheet:null,
        linkingSheetFileName:null,
        uploadedDRRSheet:null,
        DRRSheetFileName:null,
        maxDate: new Date(),
        
    }
   },
   methods: {
        formateDate() {
            this.GRNVDDateRange.startDate = moment(this.GRNVDDateRange.startDate).format("YYYY-MM-DD");
            this.GRNVDDateRange.endDate = moment(this.GRNVDDateRange.endDate).format("YYYY-MM-DD");
            this.GRNPDDateRange.startDate = moment(this.GRNPDDateRange.startDate).format("YYYY-MM-DD");
            this.GRNPDDateRange.endDate = moment(this.GRNPDDateRange.endDate).format("YYYY-MM-DD");
            this.GRNPutwayDateRange.startDate = moment(this.GRNPutwayDateRange.startDate).format("YYYY-MM-DD");
            this.GRNPutwayDateRange.endDate = moment(this.GRNPutwayDateRange.endDate).format("YYYY-MM-DD");
        },

        downloadTemplate(templateType){
            this.selectedTemplateType = templateType
            this.templateDownloadLoader= true
            const url ='/api/unicommerce/template/download';
            const payload={
                key:templateType
            }
            this.$http.post(url, payload)
            .then((response) => {
                window.location = response.data?.data;
                this.templateDownloadLoader= false
                // this.isTabWiseExporting = false;
            })
            .catch((error) => {
                // this.isTabWiseExporting = false;
                this.templateDownloadLoader= false
                console.error("Error exporting data:", error);
            });
        },

         uploadGRNSheet(e){
            this.GRNSheetLoader = true
            this.uploadedGRNSheet = e.target.files[0];
            this.GRNSheetFileName = e.target.files[0].name
            this.GRNSheetLoader = false
        },

        uploadLinkingSheet(e){
            this.linkingSheetLoader = true
            this.uploadedLinkingSheet = e.target.files[0];
            this.linkingSheetFileName = e.target.files[0].name
            this.linkingSheetLoader = false
        },

         uploadDRRSheet(e){
            this.linkingSheetFileName = null
            this.DRRSheetLoader = true
            this.uploadedDRRSheet = e.target.files[0];
            this.DRRSheetFileName = e.target.files[0].name
            this.DRRSheetLoader = false
        },

        handleGRNUploadFile() {
            const formData = new FormData();
            formData.append('vehicle_date', this.GRNVDDateRange.startDate);
            formData.append('po_date', this.GRNPDDateRange.startDate);
            formData.append('putaway_date', this.GRNPutwayDateRange.startDate);
            formData.append('sheet_type', 'reco');
            if(this.uploadedGRNSheet){
                formData.append('reco', this.uploadedGRNSheet);
            }
            else{
                 this.$bvToast.toast("Please upload GRN Sheet", {
                    title: 'Weavr Sense',
                    variant: 'danger',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 3000,
                });
                return
            }

            this.isGRNSheetUploading= true
            this.$http.post('/api/unicommerce/grn_reco/reco', formData).then(response => {
                this.GRNSheetLoader = false
                this.uploadedGRNSheet = null
                this.GRNSheetFileName = null
                this.isGRNSheetUploading= false
                this.$bvToast.toast(response.data.message, {
                    title: 'Weavr Sense',
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 3000,
                });
            }).catch(error => {
                this.GRNSheetLoader = false
                this.uploadedGRNSheet = null
                this.isGRNSheetUploading= false
            });
        },

        handleLinkUploadFile() {
            const formData = new FormData();
            formData.append('sheet_type', 'link');
            if(this.uploadedLinkingSheet){
                formData.append('link', this.uploadedLinkingSheet);
            }
            else{
                 this.$bvToast.toast("Please upload link Sheet", {
                    title: 'Weavr Sense',
                    variant: 'danger',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 3000,
                });
                return
            }

            this.linkingSheetLoader= true
            this.isLinkingSheetUploading= true
            this.$http.post('/api/unicommerce/grn_reco/reco', formData).then(response => {
                this.isLinkingSheetUploading = false
                this.uploadedLinkingSheet = null
                this.linkingSheetLoader= false
                this.linkingSheetFileName= null
                this.$bvToast.toast(response.data.message, {
                    title: 'Weavr Sense',
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 3000,
                });
            }).catch(error => {
                this.GRNSheetLoader = false
                this.uploadedLinkingSheet = null
                this.linkingSheetLoader= false
            });
        },
        handleDRRUploadFile() {
            const formData = new FormData();
            // formData.append('sheet_type', 'link');
            if(this.uploadedDRRSheet){
                formData.append('files', this.uploadedDRRSheet);
            }
            else{
                 this.$bvToast.toast("Please upload DRR Sheet", {
                    title: 'Weavr Sense',
                    variant: 'danger',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 3000,
                });
                return
            }

            this.DRRSheetLoader= true
            this.isDRRSheetUploading= true
            this.$http.put('/api/unicommerce/drr/Re_order_formatting_report', formData).then(response => {
                this.isDRRSheetUploading = false
                this.uploadedDRRSheet = null
                this.DRRSheetLoader= false
                this.DRRSheetFileName= null
                this.$bvToast.toast(response.data.message, {
                    title: 'Weavr Sense',
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 3000,
                });
            }).catch(error => {
                this.isDRRSheetUploading = false
                this.uploadedDRRSheet = null
                this.DRRSheetLoader= false
            });
        },
   }
}
</script>
<style scoped>
button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
}
.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

.navigationButton:hover {
    background: var(--accent_color-80);
}
</style>
